define('home/mixins/withInterstitialChannelCards',[
    'jquery',
    'underscore',
    'backbone',

    'core/UniqueModel',

    'home/models/ChannelProfileFeed',
    'home/models/Session',
    'home/views/PromotedChannelsCardView',
], function (
    $,
    _,
    Backbone,

    UniqueModel,

    ChannelProfileFeed,
    Session,
    PromotedChannelsCardView
) {
    'use strict';

    var CARD_SPACING = 10;
    var CHANNELS_PER_CARD = 2;

    var withInterstitialChannelCards = {
        initialize: function (_initialize, options) {
            _initialize.call(this, options);

            this.lastIntersitialCardIndex = -1;
            var boundInitializeChannelProfiles = _.bind(this.initializeChannelProfiles, this);
            var session = Session.get();

            // Wait until session has loaded, whether the user is logged in or anon
            session.loadPromise().always(function () {
                // If user is logged in (userProfile is not null), wait until following forums have been
                // fetched before initializing the channel profiles, so the channels that are followed
                // are marked as such and can be filtered out.

                var userProfile = session.getUserProfile();
                var followingForumsPromise = userProfile && userProfile.forumsFollowing.ensureFetched();

                $.when(followingForumsPromise).then(boundInitializeChannelProfiles);
            });
        },

        /**
         * Initializes list of channel profiles to show in interstitial cards. Filters out channels that
         * are already followed and randomizes the order.
         */
        initializeChannelProfiles: function () {
            var interstitialChannelProfileFeed = new UniqueModel(ChannelProfileFeed, {
                listName: ChannelProfileFeed.LIST_NAMES.promoted,
            });

            // Once the promoted channel profiles have been fetched from the api, filter and shuffle
            // them and store the finalized list of channels to promote.
            interstitialChannelProfileFeed.ensureFetched().then(_.bind(function () {
                this.interstitialChannelProfiles = interstitialChannelProfileFeed.items
                    .chain()
                    .reject(function (channelProfile) {
                        return channelProfile.channel.primaryForum.get('isFollowing');
                    })
                    .shuffle()
                    .value();
            }, this));
        },

        /**
         * Calculates the adjusted insert index to keep the interstitial cards in their
         * correct indicies. Does this by adding to the given index the number of
         * interstitial cards that have been inserted between the beginning of the
         * children and the point in which the index-th non-interstitial card is.
         */
        getAdjustedIndex: function (index) {
            var numInterstitialCards = 0;
            var numItemViews = 0;

            _.each(this.children._views, function (view) {
                // Don't need to count cards past the point where we've seen <index>
                // non-interstitial cards.
                if (numItemViews > index)
                    return;

                if (view instanceof PromotedChannelsCardView)
                    numInterstitialCards += 1;
                else
                    numItemViews += 1;
            });

            return index + numInterstitialCards;
        },

        addItemView: function (_addItemView, item, ItemView, index) {
            var adjustedIndex = this.getAdjustedIndex(index);

            // If intention is to insert item at the top of the feed, do so. Otherwise disregard
            // the given index, since it doesn't account for the interstitial cards.
            var retval = _addItemView.call(this, item, ItemView, adjustedIndex);
            adjustedIndex += 1;

            // Only add interstitial channels once the channels list has been built and every
            // CARD_SPACING number of cards apart.
            if (this.interstitialChannelProfiles &&
                adjustedIndex - this.lastIntersitialCardIndex > CARD_SPACING) {

                this.insertChannelCard(adjustedIndex);
                this.lastIntersitialCardIndex = adjustedIndex;
            }

            return retval;
        },

        insertChannelCard: function (index) {
            // Show the next CHANNELS_PER_CARD channels on this card, and remove them from the list so they
            // won't be shown on any other interstitial card.
            var channelProfiles = new Backbone.Collection(
                this.interstitialChannelProfiles.splice(0, CHANNELS_PER_CARD));

            // If there aren't enough channels to fill the card, don't show a card
            if (channelProfiles.length < CHANNELS_PER_CARD)
                return;

            // Make sure the latest discussions are fetched for the channels to be shown
            channelProfiles.invoke('ensureFetchedTopActivities');
            var cardView = new PromotedChannelsCardView({
                collection: channelProfiles,
            });

            // Store the child view itself so we can properly
            // remove and/or close it later
            this.children.add(cardView);

            // Render it and show it
            this.renderItemView(cardView, index);
        },
    };

    return function () {
        this.initialize = _.wrap(this.initialize, withInterstitialChannelCards.initialize);
        this.addItemView = _.wrap(this.addItemView, withInterstitialChannelCards.addItemView);

        _.extend(this, _.pick(withInterstitialChannelCards, [
            'insertChannelCard',
            'initializeChannelProfiles',
            'getAdjustedIndex',
        ]));
    };
});

